import { useMemo } from "react";

import { PaginationResponse } from "@/main/models/common/paginationResponse";

import { ApprovalMatrixHistoricalRequest } from "@/main/models/request";

import { ApprovalMatrixHistoricalDetailResponse, ApprovalMatrixHistoricalResponse } from "@/main/models/response";

import { approvalMatrixHistoricalApi } from "@/main/api";
import Box from "@/main/components/shared/box";
import { HistoricalChange, HistoricalDetailsData } from "@/main/components/shared/historicalGrid/historicalDetails";
import HistoricalGrid from "@/main/components/shared/historicalGrid/historicalGrid";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";
import { getTranslateByKey } from "@/main/services/utils";

interface IApprovalMatrixHistoric {
	approvalMatrixGuid: string;
	triggerReload: boolean;
}

export default function ApprovalMatrixHistoric({ approvalMatrixGuid, triggerReload }: IApprovalMatrixHistoric) {
	const request = useMemo<ApprovalMatrixHistoricalRequest>(
		() => ({
			guidApprovalMatrix: approvalMatrixGuid,
			pageIndex: PaginationEnum.PageIndexIntial,
			pageSize: PaginationEnum.PageSize15,
		}),
		[approvalMatrixGuid],
	);

	function loadMore(
		req: ApprovalMatrixHistoricalRequest,
	): Promise<PaginationResponse<ApprovalMatrixHistoricalResponse>> {
		return approvalMatrixHistoricalApi.searchGrid(req).then((res) => res.data);
	}

	function loadDetails(item: ApprovalMatrixHistoricalResponse) {
		return approvalMatrixHistoricalApi.getDetails(item.guid).then((res) => res.data.result);
	}

	function mapGridItem(item: ApprovalMatrixHistoricalResponse) {
		return {
			id: item.guid,
			action: item.nameApprovalMatrixHistoricalAction,
			date: item.dateTimeUser,
		};
	}

	function mapDetails(response: ApprovalMatrixHistoricalDetailResponse): HistoricalDetailsData {
		const changes: HistoricalChange[] =
			response.changes?.map((x) => ({
				field: x.field,
				from: x.from,
				to: x.to,
			})) ?? [];

		const groupedChanges: HistoricalChange[][] =
			response.valuesChanges?.map(
				(group) =>
					group.changes?.map((x) => ({
						field: x.field,
						from: x.from,
						to: x.to,
					})) ?? [],
			) ?? [];

		return {
			changes,
			groupedChanges,
		};
	}

	return (
		<Box title={getTranslateByKey("information.history")}>
			<HistoricalGrid
				key={`${triggerReload}`}
				request={request}
				loadMore={loadMore}
				mapGridItem={mapGridItem}
				loadDetails={loadDetails}
				mapDetails={mapDetails}
			/>
		</Box>
	);
}
